import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMain } from 'vuetify/lib/components/VMain';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "shortkey",
          rawName: "v-shortkey",
          value: ["ctrl", "/"],
          expression: "['ctrl', '/']",
        },
      ],
      staticClass: "d-flex flex-grow-1",
      on: { shortkey: _vm.onKeyup },
    },
    [
      _c(
        VSnackbar,
        {
          attrs: { timeout: -1, bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function (ref) {
                var attrs = ref.attrs
                return [
                  _c(
                    VBtn,
                    _vm._b(
                      {
                        attrs: { color: "green", small: "" },
                        on: {
                          click: function ($event) {
                            return _vm.onLoadNewVersion()
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.clic_to_update")) + " "
                      ),
                    ]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.is_new_version,
            callback: function ($$v) {
              _vm.is_new_version = $$v
            },
            expression: "is_new_version",
          },
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t("common.new_deploy_version") + " " + _vm.new_version
              ) +
              " "
          ),
        ]
      ),
      _vm.showLoading
        ? _c(
            "div",
            { staticClass: "loading-global" },
            [
              _c(
                VContainer,
                { attrs: { "fill-height": "" } },
                [
                  _c(
                    VRow,
                    { attrs: { justify: "center", align: "center" } },
                    [
                      _c(VCol, { attrs: { cols: "12", sm: "4" } }, [
                        _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c(VProgressCircular, {
                              staticClass: "text-center",
                              attrs: {
                                size: 35,
                                width: 3,
                                color: "primary",
                                indeterminate: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      !_vm.mini && !_vm.isPageHome
        ? _c(
            VNavigationDrawer,
            {
              staticClass: "elevation-1",
              staticStyle: { "z-index": "1" },
              attrs: {
                app: "",
                floating: "",
                right: _vm.$vuetify.rtl,
                light: _vm.menuTheme === "light",
                dark: _vm.menuTheme === "dark",
                permanent: "",
                touchless: true,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "prepend",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.mini || _vm.isPageHome,
                                expression: "mini || isPageHome",
                              },
                            ],
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "title font-weight-bold text-uppercase primary--text",
                              },
                              [
                                _c(
                                  "router-link",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.drawer,
                                        expression: "!drawer",
                                      },
                                    ],
                                    attrs: { to: "/" },
                                  },
                                  [
                                    _vm.env != "prod"
                                      ? _c("img", {
                                          staticStyle: {
                                            "margin-left": "47px",
                                            "padding-top": "2px",
                                            "margin-top": "10px",
                                            "margin-bottom": "4px",
                                          },
                                          attrs: {
                                            width: "160",
                                            src: require("@/assets/inca_200x75.png"),
                                          },
                                        })
                                      : _c("img", {
                                          staticStyle: {
                                            "margin-left": "47px",
                                            "padding-top": "2px",
                                            "margin-top": "10px",
                                            "margin-bottom": "4px",
                                          },
                                          attrs: {
                                            width: "160",
                                            src: require("@/assets/inca_pruebas.png"),
                                          },
                                        }),
                                  ]
                                ),
                                _c(
                                  "router-link",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.drawer,
                                        expression: "drawer",
                                      },
                                    ],
                                    attrs: { to: "/" },
                                  },
                                  [
                                    _vm.env != "prod"
                                      ? _c("img", {
                                          staticStyle: {
                                            "margin-left": "18px",
                                            "margin-top": "10px",
                                          },
                                          attrs: {
                                            width: "50",
                                            src: require("@/assets/icon_pruebas.png"),
                                          },
                                        })
                                      : _c("img", {
                                          staticStyle: {
                                            "margin-left": "18px",
                                            "margin-top": "10px",
                                          },
                                          attrs: {
                                            width: "50",
                                            src: require("@/assets/Version_ICON.png"),
                                          },
                                        }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        !_vm.mini
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "title font-weight-bold text-uppercase primary--text",
                                },
                                [
                                  _c("router-link", { attrs: { to: "/" } }, [
                                    _vm.env != "prod"
                                      ? _c("img", {
                                          staticStyle: {
                                            "margin-left": "47px",
                                            "padding-top": "2px",
                                            "margin-top": "10px",
                                            "margin-bottom": "4px",
                                          },
                                          attrs: {
                                            width: "160",
                                            src: require("@/assets/inca_pruebas.png"),
                                          },
                                        })
                                      : _c("img", {
                                          staticStyle: {
                                            "margin-left": "47px",
                                            "padding-top": "2px",
                                            "margin-top": "10px",
                                            "margin-bottom": "4px",
                                          },
                                          attrs: {
                                            width: "160",
                                            src: require("@/assets/inca_200x75.png"),
                                          },
                                        }),
                                  ]),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "append",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "pa-1 text-center" },
                          [
                            _c("toolbar-settings"),
                            _c(
                              VBtn,
                              {
                                attrs: { small: "", icon: "" },
                                on: { click: _vm.onHelpCenter },
                              },
                              [
                                _c(VIcon, { attrs: { smal: "" } }, [
                                  _vm._v("icon-help"),
                                ]),
                              ],
                              1
                            ),
                            _c("toolbar-language"),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                2044723624
              ),
              model: {
                value: _vm.drawer,
                callback: function ($$v) {
                  _vm.drawer = $$v
                },
                expression: "drawer",
              },
            },
            [
              _c(
                "div",
                { class: _vm.drawer ? "menu-inca" : "menu-inca" },
                [
                  _c("main-menu", {
                    staticClass: "pt-0 pa-3",
                    attrs: { menu: _vm.customNavigation },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm.mini || _vm.isPageHome
        ? _c(
            VNavigationDrawer,
            {
              staticClass: "elevation-1",
              staticStyle: { "z-index": "1" },
              attrs: {
                app: "",
                floating: "",
                right: _vm.$vuetify.rtl,
                light: _vm.menuTheme === "light",
                dark: _vm.menuTheme === "dark",
                permanent: "",
                "mini-variant": _vm.drawer,
                "mini-variant-width": 86,
                touchless: true,
              },
              on: {
                "update:miniVariant": function ($event) {
                  _vm.drawer = $event
                },
                "update:mini-variant": function ($event) {
                  _vm.drawer = $event
                },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "prepend",
                    fn: function () {
                      return [
                        _c("div", {}, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "title font-weight-bold text-uppercase primary--text",
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.drawer,
                                      expression: "!drawer",
                                    },
                                  ],
                                  attrs: { to: "/" },
                                },
                                [
                                  _vm.env != "prod"
                                    ? _c("img", {
                                        staticStyle: {
                                          "margin-left": "47px",
                                          "padding-top": "2px",
                                          "margin-top": "10px",
                                          "margin-bottom": "4px",
                                        },
                                        attrs: {
                                          width: "160",
                                          src: require("@/assets/inca_pruebas.png"),
                                        },
                                      })
                                    : _c("img", {
                                        staticStyle: {
                                          "margin-left": "47px",
                                          "padding-top": "2px",
                                          "margin-top": "10px",
                                          "margin-bottom": "4px",
                                        },
                                        attrs: {
                                          width: "160",
                                          src: require("@/assets/inca_200x75.png"),
                                        },
                                      }),
                                ]
                              ),
                              _c(
                                "router-link",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.drawer,
                                      expression: "drawer",
                                    },
                                  ],
                                  attrs: { to: "/" },
                                },
                                [
                                  _vm.env != "prod"
                                    ? _c("img", {
                                        staticStyle: {
                                          "margin-left": "18px",
                                          "margin-top": "10px",
                                        },
                                        attrs: {
                                          width: "50",
                                          src: require("@/assets/icon_pruebas.png"),
                                        },
                                      })
                                    : _c("img", {
                                        staticStyle: {
                                          "margin-left": "18px",
                                          "margin-top": "10px",
                                        },
                                        attrs: {
                                          width: "50",
                                          src: require("@/assets/Version_ICON.png"),
                                        },
                                      }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "append",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "pa-1 text-center" },
                          [
                            _c("toolbar-settings"),
                            _c(
                              VBtn,
                              {
                                attrs: { small: "", icon: "" },
                                on: { click: _vm.onHelpCenter },
                              },
                              [
                                _c(VIcon, { attrs: { smal: "" } }, [
                                  _vm._v("icon-help"),
                                ]),
                              ],
                              1
                            ),
                            _c("toolbar-language", {
                              attrs: { "is-mini": _vm.drawer },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                2487635574
              ),
              model: {
                value: _vm.drawer,
                callback: function ($$v) {
                  _vm.drawer = $$v
                },
                expression: "drawer",
              },
            },
            [
              _c(
                "div",
                { class: _vm.drawer ? "menu-inca" : "menu-inca" },
                [
                  _c("main-menu", {
                    staticClass: "pt-0 pa-3",
                    attrs: {
                      isPageHome: _vm.isPageHome,
                      menu: _vm.customNavigation,
                      "is-mini": _vm.drawer,
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "toolbar-wrapper" },
        [
          _vm.isPageHome
            ? _c(
                VAppBar,
                {
                  staticStyle: {
                    "background-color": "#0069E2 !important",
                    height: "9% !important",
                  },
                  attrs: { app: "", dark: "" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-grow-1 align-center" },
                    [
                      _c(
                        VAppBarNavIcon,
                        {
                          ref: "ref-app-bar",
                          staticStyle: {
                            right: "40px",
                            position: "relative",
                            "z-index": "3",
                          },
                          attrs: { light: "" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.onDrawerMini()
                            },
                          },
                        },
                        [
                          _c(
                            VAvatar,
                            {
                              attrs: {
                                rounded: "pill",
                                color: "white",
                                size: "40",
                              },
                            },
                            [
                              !_vm.drawer
                                ? _c(
                                    VIcon,
                                    {
                                      staticStyle: {
                                        "font-size": "30px",
                                        "background-color": "white",
                                        color: "gray",
                                      },
                                    },
                                    [_vm._v("mdi-chevron-left-circle-outline")]
                                  )
                                : _vm._e(),
                              _vm.drawer
                                ? _c(
                                    VIcon,
                                    {
                                      staticStyle: {
                                        "font-size": "30px",
                                        "background-color": "white",
                                        color: "gray",
                                      },
                                    },
                                    [_vm._v("mdi-chevron-right-circle-outline")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(VToolbarTitle, { staticClass: "mt-3" }, [
                        _vm._v(
                          "Hola, " +
                            _vm._s(
                              _vm.userInfo.displayName
                                ? _vm.userInfo.displayName
                                : _vm.userInfo.email
                            ) +
                            " 👋"
                        ),
                        _c("br"),
                        _c("p", { staticStyle: { "font-size": "13px" } }, [
                          _vm._v(
                            "Revisa tus últimas actividades en INCA Platform"
                          ),
                        ]),
                      ]),
                      _c(VSpacer),
                      _c("toolbar-user"),
                    ],
                    1
                  ),
                ]
              )
            : _c(
                VAppBar,
                {
                  attrs: {
                    app: "",
                    color: _vm.isToolbarDetached ? "surface" : undefined,
                    flat: _vm.isToolbarDetached,
                    light: _vm.toolbarTheme === "light",
                    dark: _vm.toolbarTheme === "dark",
                    elevation: 0,
                  },
                },
                [
                  _c(
                    VCard,
                    {
                      staticClass: "flex-grow-1 d-flex",
                      class: [
                        _vm.isToolbarDetached ? "pa-1 mt-3 mx-1" : "pa-0 ma-0",
                      ],
                      attrs: { flat: !_vm.isToolbarDetached },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-grow-1 align-center" },
                        [
                          _vm.showSearch
                            ? _c(VTextField, {
                                attrs: {
                                  "append-icon": "icon-decline",
                                  placeholder: _vm.$t("common.search_commun"),
                                  "prepend-inner-icon": "",
                                  "hide-details": "",
                                  solo: "",
                                  flat: "",
                                  autofocus: "",
                                  type: "search",
                                  pattern: _vm.SEARCH_PATTERN,
                                },
                                on: {
                                  "click:append": function ($event) {
                                    _vm.showSearch = false
                                  },
                                  input: _vm.sugerir,
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.sendToSearch($event)
                                  },
                                },
                                model: {
                                  value: _vm.q,
                                  callback: function ($$v) {
                                    _vm.q = $$v
                                  },
                                  expression: "q",
                                },
                              })
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-grow-1 align-center",
                                },
                                [
                                  _c(
                                    VAppBarNavIcon,
                                    {
                                      ref: "ref-app-bar",
                                      staticStyle: {
                                        right: "40px",
                                        position: "relative",
                                        "z-index": "3",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.onDrawerMini()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        VAvatar,
                                        {
                                          attrs: {
                                            rounded: "pill",
                                            color: "white",
                                            size: "40",
                                          },
                                        },
                                        [
                                          !_vm.drawer
                                            ? _c(
                                                VIcon,
                                                {
                                                  staticStyle: {
                                                    "font-size": "30px",
                                                    "background-color": "white",
                                                    color: "gray",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "mdi-chevron-left-circle-outline"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.drawer
                                            ? _c(
                                                VIcon,
                                                {
                                                  staticStyle: {
                                                    "font-size": "30px",
                                                    "background-color": "white",
                                                    color: "gray",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "mdi-chevron-right-circle-outline"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(VSpacer, {
                                    staticClass: "d-none d-lg-block",
                                  }),
                                  _c("div", { staticClass: "caja-buscador" }, [
                                    _vm.isPageDataPlatform
                                      ? _c(
                                          "div",
                                          {
                                            ref: "ctn_buscador",
                                            staticClass: "contenedor-buscador",
                                          },
                                          [
                                            _c(
                                              VMenu,
                                              {
                                                attrs: {
                                                  "offset-y": "",
                                                  "close-on-content-click": false,
                                                  "max-width":
                                                    _vm.getWithContainerBuscador(),
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.onOpenBuscador(
                                                      $event
                                                    )
                                                  },
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function (ref) {
                                                        var on = ref.on
                                                        var attrs = ref.attrs
                                                        return [
                                                          _c(
                                                            VTextField,
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "mx-1 hidden-xs-only",
                                                                  attrs: {
                                                                    placeholder:
                                                                      _vm.$t(
                                                                        "common.search_commun"
                                                                      ),
                                                                    "prepend-inner-icon":
                                                                      "icon-search",
                                                                    "hide-details":
                                                                      "",
                                                                    filled: "",
                                                                    rounded: "",
                                                                    dense: "",
                                                                    type: "search",
                                                                    pattern:
                                                                      _vm.SEARCH_PATTERN,
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      _vm.debounceInput,
                                                                    keyup:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          !$event.type.indexOf(
                                                                            "key"
                                                                          ) &&
                                                                          _vm._k(
                                                                            $event.keyCode,
                                                                            "enter",
                                                                            13,
                                                                            $event.key,
                                                                            "Enter"
                                                                          )
                                                                        ) {
                                                                          return null
                                                                        }
                                                                        return _vm.sendToSearch(
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "append",
                                                                          fn: function () {
                                                                            return [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "d-flex align-center",
                                                                                  staticStyle:
                                                                                    {
                                                                                      height:
                                                                                        "100%",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "caption",
                                                                                      class:
                                                                                        !_vm.semanticSearch
                                                                                          ? "primary--text"
                                                                                          : "grey--text",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "Clásica"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    VSwitch,
                                                                                    {
                                                                                      staticClass:
                                                                                        "mx-1 mt-0",
                                                                                      attrs:
                                                                                        {
                                                                                          "hide-details":
                                                                                            "",
                                                                                          dense:
                                                                                            "",
                                                                                        },
                                                                                      on: {
                                                                                        click:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            $event.stopPropagation()
                                                                                          },
                                                                                      },
                                                                                      model:
                                                                                        {
                                                                                          value:
                                                                                            _vm.semanticSearch,
                                                                                          callback:
                                                                                            function (
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.semanticSearch =
                                                                                                $$v
                                                                                            },
                                                                                          expression:
                                                                                            "semanticSearch",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "caption",
                                                                                      class:
                                                                                        _vm.semanticSearch
                                                                                          ? "primary--text"
                                                                                          : "grey--text",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "Semántica"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ]
                                                                          },
                                                                          proxy: true,
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                  model: {
                                                                    value:
                                                                      _vm.q,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.q =
                                                                          $$v
                                                                      },
                                                                    expression:
                                                                      "q",
                                                                  },
                                                                },
                                                                "v-text-field",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            )
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  3374174403
                                                ),
                                                model: {
                                                  value: _vm.menuBuscador,
                                                  callback: function ($$v) {
                                                    _vm.menuBuscador = $$v
                                                  },
                                                  expression: "menuBuscador",
                                                },
                                              },
                                              [
                                                _c(
                                                  VCard,
                                                  [
                                                    _c(
                                                      VContainer,
                                                      {
                                                        staticClass:
                                                          "caja-lista-buscador",
                                                      },
                                                      [
                                                        _c(
                                                          VList,
                                                          {
                                                            attrs: {
                                                              dense: "",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.searchs,
                                                            function (item) {
                                                              return _c(
                                                                VListItem,
                                                                {
                                                                  key: item.id,
                                                                  staticClass:
                                                                    "search-item",
                                                                },
                                                                [
                                                                  _c(
                                                                    VListItemAction,
                                                                    [
                                                                      _c(
                                                                        VIcon,
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              small:
                                                                                "",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "mdi-history"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    VListItemContent,
                                                                    [
                                                                      _c(
                                                                        VListItemTitle,
                                                                        {
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.searchAgain(
                                                                                  item.texto,
                                                                                  $event
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "search-text",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item.texto
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    VListItemAction,
                                                                    [
                                                                      _c(
                                                                        VIcon,
                                                                        {
                                                                          staticClass:
                                                                            "remove-icon",
                                                                          attrs:
                                                                            {
                                                                              small:
                                                                                "",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.removeSearch(
                                                                                  item.id
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "mdi-close"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                        _vm.isPageSearch
                                                          ? _c(VRow, [
                                                              _vm.estaBuscando
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "text-center w-100",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        VProgressCircular,
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              size: 30,
                                                                              color:
                                                                                "primary",
                                                                              indeterminate:
                                                                                "",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                            ])
                                                          : _vm._e(),
                                                        _vm.isPageSearch
                                                          ? _c(
                                                              VRow,
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "show",
                                                                    rawName:
                                                                      "v-show",
                                                                    value:
                                                                      !_vm.existeBusqueda &&
                                                                      !_vm.estaBuscando,
                                                                    expression:
                                                                      "!existeBusqueda && !estaBuscando",
                                                                  },
                                                                ],
                                                              },
                                                              [
                                                                _c(
                                                                  VCol,
                                                                  {
                                                                    attrs: {
                                                                      sm: "12",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "margin-bottom":
                                                                              "0",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "search.no_results"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm.isPageSearch
                                                          ? _c(
                                                              VRow,
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "show",
                                                                    rawName:
                                                                      "v-show",
                                                                    value:
                                                                      _vm.existeBusqueda &&
                                                                      !_vm.estaBuscando,
                                                                    expression:
                                                                      "existeBusqueda && !estaBuscando",
                                                                  },
                                                                ],
                                                              },
                                                              [
                                                                _c(
                                                                  VCol,
                                                                  {
                                                                    attrs: {
                                                                      sm: "12",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      VList,
                                                                      {
                                                                        staticClass:
                                                                          "overflow-y-auto",
                                                                        attrs: {
                                                                          "two-line":
                                                                            "",
                                                                          "max-height":
                                                                            _vm.getClientHeight(),
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          VListItemGroup,
                                                                          [
                                                                            _vm._l(
                                                                              _vm
                                                                                .encontrado
                                                                                .busqueda,
                                                                              function (
                                                                                item,
                                                                                index
                                                                              ) {
                                                                                return [
                                                                                  _c(
                                                                                    VListItem,
                                                                                    {
                                                                                      key:
                                                                                        "item" +
                                                                                        item.id +
                                                                                        "_" +
                                                                                        item.titulo +
                                                                                        "_" +
                                                                                        _vm.getRamdonKey(),
                                                                                    },
                                                                                    [
                                                                                      [
                                                                                        _c(
                                                                                          VListItemContent,
                                                                                          [
                                                                                            _c(
                                                                                              VListItemTitle,
                                                                                              {
                                                                                                attrs:
                                                                                                  {
                                                                                                    primary:
                                                                                                      "",
                                                                                                  },
                                                                                                domProps:
                                                                                                  {
                                                                                                    textContent:
                                                                                                      _vm._s(
                                                                                                        item.titulo
                                                                                                      ),
                                                                                                  },
                                                                                              }
                                                                                            ),
                                                                                            _c(
                                                                                              VListItemSubtitle,
                                                                                              {
                                                                                                staticClass:
                                                                                                  "text--primary",
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "Proyecto: " +
                                                                                                    _vm._s(
                                                                                                      item.proyecto
                                                                                                    )
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                            _c(
                                                                                              VListItemSubtitle,
                                                                                              {
                                                                                                staticClass:
                                                                                                  "text--primary",
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "Dominio: " +
                                                                                                    _vm._s(
                                                                                                      item.dominio
                                                                                                    )
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                            item.tipo_objeto ==
                                                                                            _vm
                                                                                              .TYPSE_SENSE_TYPE_OBJECTS
                                                                                              .TABLE
                                                                                              ? _c(
                                                                                                  VListItemSubtitle,
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "text--primary",
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "Tamaño: " +
                                                                                                        _vm._s(
                                                                                                          _vm.formatBytes(
                                                                                                            item.numBytes
                                                                                                          )
                                                                                                        )
                                                                                                    ),
                                                                                                  ]
                                                                                                )
                                                                                              : _vm._e(),
                                                                                            item.tipo_objeto ==
                                                                                            _vm
                                                                                              .TYPSE_SENSE_TYPE_OBJECTS
                                                                                              .TABLE
                                                                                              ? _c(
                                                                                                  VListItemSubtitle,
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "text--primary",
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "Registros: " +
                                                                                                        _vm._s(
                                                                                                          _vm.formatNumber(
                                                                                                            item.numRows
                                                                                                          )
                                                                                                        )
                                                                                                    ),
                                                                                                  ]
                                                                                                )
                                                                                              : _vm._e(),
                                                                                            item.distance !==
                                                                                            undefined
                                                                                              ? _c(
                                                                                                  VListItemSubtitle,
                                                                                                  [
                                                                                                    _c(
                                                                                                      "b",
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          "Similitud semántica:"
                                                                                                        ),
                                                                                                      ]
                                                                                                    ),
                                                                                                    _c(
                                                                                                      VChip,
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "mx-1",
                                                                                                        attrs:
                                                                                                          {
                                                                                                            "x-small":
                                                                                                              "",
                                                                                                            color:
                                                                                                              _vm.similarityColor(
                                                                                                                item.distance
                                                                                                              ),
                                                                                                            dark: "",
                                                                                                          },
                                                                                                      },
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          _vm._s(
                                                                                                            _vm.similarityPercent(
                                                                                                              item.distance
                                                                                                            )
                                                                                                          ) +
                                                                                                            "%"
                                                                                                        ),
                                                                                                      ]
                                                                                                    ),
                                                                                                    _c(
                                                                                                      VProgressLinear,
                                                                                                      {
                                                                                                        staticStyle:
                                                                                                          {
                                                                                                            "max-width":
                                                                                                              "100px",
                                                                                                            display:
                                                                                                              "inline-flex",
                                                                                                            "vertical-align":
                                                                                                              "middle",
                                                                                                          },
                                                                                                        attrs:
                                                                                                          {
                                                                                                            value:
                                                                                                              _vm.similarityPercent(
                                                                                                                item.distance
                                                                                                              ),
                                                                                                            color:
                                                                                                              _vm.similarityColor(
                                                                                                                item.distance
                                                                                                              ),
                                                                                                            height:
                                                                                                              "4",
                                                                                                            rounded:
                                                                                                              "",
                                                                                                          },
                                                                                                      }
                                                                                                    ),
                                                                                                  ],
                                                                                                  1
                                                                                                )
                                                                                              : _c(
                                                                                                  VListItemSubtitle,
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "Encontrado en: " +
                                                                                                        _vm._s(
                                                                                                          item.field
                                                                                                        ) +
                                                                                                        " "
                                                                                                    ),
                                                                                                    _c(
                                                                                                      "span",
                                                                                                      {
                                                                                                        domProps:
                                                                                                          {
                                                                                                            innerHTML:
                                                                                                              _vm._s(
                                                                                                                item.snippet
                                                                                                              ),
                                                                                                          },
                                                                                                      }
                                                                                                    ),
                                                                                                  ]
                                                                                                ),
                                                                                          ],
                                                                                          1
                                                                                        ),
                                                                                        _c(
                                                                                          VListItemAction,
                                                                                          [
                                                                                            _c(
                                                                                              VBtn,
                                                                                              {
                                                                                                class:
                                                                                                  "color-" +
                                                                                                  item.tipo_objeto,
                                                                                                attrs:
                                                                                                  {
                                                                                                    "x-small":
                                                                                                      "",
                                                                                                    dark: "",
                                                                                                  },
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    item.tipo_objeto
                                                                                                  )
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                            _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "text-center",
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  VBtn,
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "ml-1",
                                                                                                    attrs:
                                                                                                      {
                                                                                                        "x-small":
                                                                                                          "",
                                                                                                        outlined:
                                                                                                          "",
                                                                                                        color:
                                                                                                          "secondary",
                                                                                                        dark: "",
                                                                                                      },
                                                                                                    on: {
                                                                                                      click:
                                                                                                        function (
                                                                                                          $event
                                                                                                        ) {
                                                                                                          return _vm.onVerObjeto(
                                                                                                            item
                                                                                                          )
                                                                                                        },
                                                                                                    },
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      _vm._s(
                                                                                                        _vm.$t(
                                                                                                          "search.view"
                                                                                                        )
                                                                                                      )
                                                                                                    ),
                                                                                                  ]
                                                                                                ),
                                                                                                _vm.check_access_function(
                                                                                                  item.source,
                                                                                                  item.dominio
                                                                                                )
                                                                                                  ? _c(
                                                                                                      VBtn,
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "ml-1",
                                                                                                        attrs:
                                                                                                          {
                                                                                                            "x-small":
                                                                                                              "",
                                                                                                            outlined:
                                                                                                              "",
                                                                                                            color:
                                                                                                              "secondary",
                                                                                                            dark: "",
                                                                                                          },
                                                                                                        on: {
                                                                                                          click:
                                                                                                            function (
                                                                                                              $event
                                                                                                            ) {
                                                                                                              return _vm.onRequestObjeto(
                                                                                                                item
                                                                                                              )
                                                                                                            },
                                                                                                        },
                                                                                                      },
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          _vm._s(
                                                                                                            _vm.$t(
                                                                                                              "search.request"
                                                                                                            )
                                                                                                          )
                                                                                                        ),
                                                                                                      ]
                                                                                                    )
                                                                                                  : _vm._e(),
                                                                                                _c(
                                                                                                  VBtn,
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "ml-1",
                                                                                                    attrs:
                                                                                                      {
                                                                                                        "x-small":
                                                                                                          "",
                                                                                                        outlined:
                                                                                                          "",
                                                                                                        color:
                                                                                                          "secondary",
                                                                                                        dark: "",
                                                                                                      },
                                                                                                    on: {
                                                                                                      click:
                                                                                                        function (
                                                                                                          $event
                                                                                                        ) {
                                                                                                          return _vm.onChangeObjeto(
                                                                                                            item
                                                                                                          )
                                                                                                        },
                                                                                                    },
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      _vm._s(
                                                                                                        _vm.$t(
                                                                                                          "search.change"
                                                                                                        )
                                                                                                      )
                                                                                                    ),
                                                                                                  ]
                                                                                                ),
                                                                                              ],
                                                                                              1
                                                                                            ),
                                                                                          ],
                                                                                          1
                                                                                        ),
                                                                                      ],
                                                                                    ],
                                                                                    2
                                                                                  ),
                                                                                ]
                                                                              }
                                                                            ),
                                                                          ],
                                                                          2
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _vm.isPageSearch
                                                          ? _c(
                                                              VRow,
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "show",
                                                                    rawName:
                                                                      "v-show",
                                                                    value:
                                                                      _vm.existeBusqueda,
                                                                    expression:
                                                                      "existeBusqueda",
                                                                  },
                                                                ],
                                                              },
                                                              [
                                                                _c(VCol, [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "text-center",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-link",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              color:
                                                                                "#292929",
                                                                              "text-decoration":
                                                                                "underline #292929",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              _vm.sendToSearch,
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "search.view"
                                                                              )
                                                                            ) +
                                                                              " " +
                                                                              _vm._s(
                                                                                _vm
                                                                                  .encontrado
                                                                                  .found
                                                                              ) +
                                                                              " " +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "search.coincidences"
                                                                                )
                                                                              )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]),
                                  _c(VSpacer, {
                                    staticClass: "d-block d-sm-none",
                                  }),
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "d-block d-sm-none",
                                      attrs: { icon: "" },
                                      on: {
                                        click: function ($event) {
                                          _vm.showSearch = true
                                        },
                                      },
                                    },
                                    [_c(VIcon, [_vm._v("icon-search")])],
                                    1
                                  ),
                                  _c("toolbar-attributes"),
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        _vm.$vuetify.rtl ? "ml-1" : "mr-1",
                                      ],
                                    },
                                    [
                                      _c("toolbar-notifications", {
                                        key: _vm.keyNotifications,
                                        on: { new_receive: _vm.new_receive },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("toolbar-user"),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
        ],
        1
      ),
      _c(
        VMain,
        { staticStyle: { "margin-bottom": "10% !important" } },
        [
          _c(
            VContainer,
            {
              staticClass: "fill-height",
              attrs: { fluid: !_vm.isContentBoxed },
            },
            [_c(VLayout, { key: _vm.$route.path }, [_vm._t("default")], 2)],
            1
          ),
          _c(
            VFooter,
            {
              staticStyle: { "background-color": "rgba(249,249,249,0)" },
              attrs: { app: "", inset: "" },
            },
            [
              _c(VSpacer),
              _c("div", { staticClass: "overline" }, [
                _vm._v(
                  " " + _vm._s("v." + _vm.deploy_version) + " © Intercorp "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showMessage
        ? _c(
            "div",
            { staticClass: "bg-block" },
            [
              _c("message-component", {
                staticClass: "vertical-center",
                attrs: {
                  list_path: _vm.toastMessage.list_path,
                  path: _vm.toastMessage.path,
                  color: _vm.toastMessage.color,
                  icon: _vm.toastMessage.icon,
                  title: _vm.toastMessage.title,
                  subtitle: _vm.toastMessage.subtitle,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME,
          attrs: { title: "Request Access", width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-access-request-table-component", {
                key: _vm.key_request,
                ref: _vm.MODAL_NAME + "_body",
                attrs: {
                  tplToWork: _vm.objToRequest,
                  isSynapse: _vm.isSynapse,
                },
                on: {
                  submit: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME].onClose()
                  },
                  cancel: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[_vm.MODAL_NAME + "_body"].onSubmit($event)
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-send")]),
                  _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME_METADATA,
          attrs: { title: "Request Change Metadata", width: 1800 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-metadata-table-component", {
                key: _vm.key_meta,
                ref: _vm.MODAL_NAME_METADATA + "_body",
                attrs: {
                  tplToWork: _vm.objToRequest,
                  isChangeRequest: _vm.TYPE_CHANGE_METADA.CHANGE_REQUEST,
                  "hide-env": true,
                },
                on: {
                  submit: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_METADATA].onClose()
                  },
                  cancel: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_METADATA].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[_vm.MODAL_NAME_METADATA + "_body"].validateForm(
                        "ok",
                        $event
                      )
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-send")]),
                  _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME_METADATA_VIEW,
          attrs: { title: "Metadata Table Detail", width: 1800 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-metadata-table-component", {
                key: _vm.key_view,
                ref: "viewmetadataTableRef",
                attrs: {
                  tplToWork: _vm.objToRequest,
                  isChangeRequest: _vm.TYPE_CHANGE_METADA.VIEWER_ONLY,
                  lazyLoadParams: _vm.lazyLoadParamsForViewer,
                  "hide-env": true,
                },
                on: {
                  submit: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_METADATA_VIEW].onClose()
                  },
                  cancel: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_METADATA_VIEW].oncClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsLeft" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "secondary", outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.viewmetadataTableRef.clickDownloadCSV()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("icon-download"),
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("botones.boton_download_metadata")) +
                      " "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_DATASOURCE_METADATA_VIEW,
          attrs: {
            title:
              (_vm.isReadonly ? "VIEW" : "CHANGE") + " METADATA DATASOURCE",
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-meta-datasource", {
                ref: _vm.MODAL_DATASOURCE_METADATA_VIEW + "_body",
                attrs: {
                  item: _vm.objDatasource,
                  showButtons: !_vm.isReadonly,
                  readonly: _vm.isReadonly,
                  isChangeRequest: _vm.isChangeRequest,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[
                      _vm.MODAL_DATASOURCE_METADATA_VIEW
                    ].onClose()
                  },
                },
              }),
            ],
            1
          ),
          !_vm.isReadonly
            ? _c(
                "template",
                { slot: "btnsRight" },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[
                            _vm.MODAL_DATASOURCE_METADATA_VIEW + "_body"
                          ].onSave()
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-send"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_SELECT_USER_TABLEAU,
          attrs: {
            title:
              _vm.tableauType == "datasource"
                ? _vm.objDatasource.path_name +
                  "/" +
                  _vm.objDatasource.object_name
                : _vm.objDashboard.path_name +
                  "/" +
                  _vm.objDashboard.object_name,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-select-tableau-user", {
                ref: _vm.MODAL_SELECT_USER_TABLEAU + "_body",
                attrs: {
                  userTableauOptions: _vm.userTableauOptions,
                  item:
                    _vm.tableauType == "datasource"
                      ? _vm.objDatasource
                      : _vm.objDashboard,
                  tableauType: _vm.tableauType,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[_vm.MODAL_SELECT_USER_TABLEAU].onClose()
                  },
                  openMetaDatasource: function ($event) {
                    _vm.tableauType == "datasource"
                      ? _vm.openMetaDatasource
                      : _vm.openMetaWorkbook
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.MODAL_SELECT_USER_TABLEAU + "_body"
                      ].onSubmit($event)
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("icon-check"),
                  ]),
                  _vm._v(" " + _vm._s(_vm.$t("botones.boton_aceptar")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_DATASOURCE_METADATA_ACCESS,
          attrs: { title: "DATASOURCE ACCESS REQUEST", width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-access-request-datasource", {
                ref: _vm.MODAL_DATASOURCE_METADATA_ACCESS + "_body",
                attrs: {
                  item: _vm.objDatasource,
                  userTableau: _vm.userTableau,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[
                      _vm.MODAL_DATASOURCE_METADATA_ACCESS
                    ].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.MODAL_DATASOURCE_METADATA_ACCESS + "_body"
                      ].onSubmit($event)
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-send")]),
                  _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_WORKBOOK_METADATA_VIEW,
          attrs: {
            title: (_vm.isReadonly ? "View" : "Change") + " Metadata workbook",
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-meta-dashboard", {
                ref: _vm.MODAL_WORKBOOK_METADATA_VIEW + "_body",
                attrs: {
                  item: _vm.objDashboard,
                  showButtons: !_vm.isReadonly,
                  readonly: _vm.isReadonly,
                  isChangeRequest: _vm.isChangeRequest,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[_vm.MODAL_WORKBOOK_METADATA_VIEW].onClose()
                  },
                },
              }),
            ],
            1
          ),
          !_vm.isReadonly
            ? _c(
                "template",
                { slot: "btnsRight" },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[
                            _vm.MODAL_WORKBOOK_METADATA_VIEW + "_body"
                          ].onSave()
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-send"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_WORKBOOK_METADATA_ACCESS,
          attrs: { title: "WORKBOOK ACCESS REQUEST", width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-access-request-workbook", {
                ref: _vm.MODAL_WORKBOOK_METADATA_ACCESS + "_body",
                attrs: {
                  "(": "",
                  item: _vm.objDashboard,
                  userTableau: _vm.userTableau,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[
                      _vm.MODAL_WORKBOOK_METADATA_ACCESS
                    ].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.MODAL_WORKBOOK_METADATA_ACCESS + "_body"
                      ].onSubmit($event)
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-send")]),
                  _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_PREVIEW_IMAGE,
          attrs: { title: _vm.currentView.name, width: 850 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("b-img", {
                attrs: { src: _vm.currentImage.base64, fluid: "" },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_DATASET_METADATA_VIEW,
          attrs: {
            title: (_vm.isReadonly ? "View" : "Change") + " Metadata Dataset",
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-meta-dataset", {
                ref: _vm.MODAL_DATASET_METADATA_VIEW + "_body",
                attrs: {
                  item: _vm.objDataset,
                  dataset_id: _vm.objDataset.dataset_id,
                  showButtons: !_vm.isReadonly,
                  readonly: _vm.isReadonly,
                  isChangeRequest: _vm.isChangeRequest,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[_vm.MODAL_DATASET_METADATA_VIEW].onClose()
                  },
                },
              }),
            ],
            1
          ),
          !_vm.isReadonly
            ? _c(
                "template",
                { slot: "btnsRight" },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[
                            _vm.MODAL_DATASET_METADATA_VIEW + "_body"
                          ].onSave()
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-send"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_SELECT_USER_BI,
          attrs: {
            title:
              _vm.biType == "dataset"
                ? _vm.objDataset.path_name + "/" + _vm.objDataset.object_name
                : _vm.objReport.path_name + "/" + _vm.objReport.object_name,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-select-bi-user", {
                ref: _vm.MODAL_SELECT_USER_BI + "_body",
                attrs: {
                  userBIOptions: _vm.userBIOptions,
                  item:
                    _vm.biType == "dataset" ? _vm.objDataset : _vm.objReport,
                  biType: _vm.biType,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[_vm.MODAL_SELECT_USER_BI].onClose()
                  },
                  openMetaDataset: _vm.openMetaDataset,
                  openMetaReport: _vm.openMetaReport,
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[_vm.MODAL_SELECT_USER_BI + "_body"].onSubmit(
                        $event
                      )
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("botones.boton_aceptar")) + " ")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_DATASET_METADATA_ACCESS,
          attrs: { title: "DATASET ACCESS REQUEST", width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-access-request-dataset", {
                ref: _vm.MODAL_DATASET_METADATA_ACCESS + "_body",
                attrs: {
                  item: _vm.objDataset,
                  userBI: _vm.userBI,
                  emailBI: _vm.emailBI,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[
                      _vm.MODAL_DATASET_METADATA_ACCESS
                    ].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.MODAL_DATASET_METADATA_ACCESS + "_body"
                      ].onSubmit($event)
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-send")]),
                  _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_REPORT_METADATA_VIEW,
          attrs: {
            title: (_vm.isReadonly ? "View" : "Change") + " Report Metadata",
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-meta-report", {
                ref: _vm.MODAL_REPORT_METADATA_VIEW + "_body",
                attrs: {
                  item: _vm.objReport,
                  report_id: _vm.objReport.report_id,
                  showButtons: !_vm.isReadonly,
                  readonly: _vm.isReadonly,
                  isChangeRequest: _vm.isChangeRequest,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[_vm.MODAL_REPORT_METADATA_VIEW].onClose()
                  },
                },
              }),
            ],
            1
          ),
          !_vm.isReadonly
            ? _c(
                "template",
                { slot: "btnsRight" },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[
                            _vm.MODAL_REPORT_METADATA_VIEW + "_body"
                          ].onSave()
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-send"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_REPORT_METADATA_ACCESS,
          attrs: { title: _vm.$t("my_tasks.form_request_title"), width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-access-request-report", {
                ref: _vm.MODAL_REPORT_METADATA_ACCESS + "_body",
                attrs: {
                  item: _vm.objReport,
                  userBI: _vm.userBI,
                  emailBI: _vm.emailBI,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[_vm.MODAL_REPORT_METADATA_ACCESS].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.MODAL_REPORT_METADATA_ACCESS + "_body"
                      ].onSubmit($event)
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-send")]),
                  _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_REPORT_METADATA_VIEW_GDS,
          attrs: {
            title: _vm.isChangeRequest ? "Change report metadata" : "Metadata",
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-meta-report-datastudio", {
                ref: _vm.MODAL_REPORT_METADATA_VIEW_GDS + "_body",
                attrs: {
                  item: _vm.objReportGds,
                  report_id: _vm.objReportGds.report_id,
                  showButtons: !_vm.isReadonly,
                  readonly: _vm.isReadonly,
                  isChangeRequest: _vm.isChangeRequest,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[
                      _vm.MODAL_REPORT_METADATA_VIEW_GDS
                    ].onClose()
                  },
                },
              }),
            ],
            1
          ),
          !_vm.isReadonly
            ? _c(
                "template",
                { slot: "btnsRight" },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[
                            _vm.MODAL_REPORT_METADATA_VIEW_GDS + "_body"
                          ].onSave()
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-send"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_REPORT_METADATA_ACCESS_GDS,
          attrs: { title: _vm.$t("my_tasks.form_request_title"), width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-access-request-report-gds", {
                ref: _vm.MODAL_REPORT_METADATA_ACCESS_GDS + "_body",
                attrs: {
                  item: _vm.objReportGds,
                  userBI: _vm.userBI,
                  emailBI: _vm.emailBI,
                },
                on: {
                  onCloseModal: function ($event) {
                    return _vm.$refs[
                      _vm.MODAL_REPORT_METADATA_ACCESS_GDS
                    ].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.MODAL_REPORT_METADATA_ACCESS_GDS + "_body"
                      ].onSubmit($event)
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-send")]),
                  _vm._v(" " + _vm._s(_vm.$t("btns.request")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm.shouldShowFloatingButton ? _c("FloatingButtonComponent") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }